import { LOGIN } from '../../endpoints';

enum AccountType {
  KIMCRM = 'kimcrm',
  NON_KIMCRM = 'non-kimcrm',
}

interface UserResponse {
  email: string;
  name: string;
  account: string;
  accountType: AccountType;
}

interface LoginResponse {
  token: string;
  msg: string;
  user: UserResponse;
}

const loginApi = async (
  email: string,
  password: string,
  options?: Pick<RequestInit, 'signal'>
): Promise<LoginResponse> => {
  try {
    const response = await fetch(LOGIN, {
      method: 'POST',
      body: JSON.stringify({ email, password }),
      headers: {
        'Content-Type': 'application/json',
      },
      ...options,
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.msg);
    }

    return result;
  } catch (error) {
    throw error;
  }
};

export { loginApi, type LoginResponse };